const confVideo = {
  selector: 'a[data-w-e-type="videoAttachment"]',
  parseElemHtml(elem, children, editor) {
    // elem HTML 结构 <span data-w-e-type="mention" data-w-e-is-void data-w-e-is-inline data-value="张三" data-info="xxx">@张三</span>

    const videoUrl = elem.getAttribute("data-videoUrl") || "";
    const videoName = elem.getAttribute("data-videoName") || "";
    const videoCover = elem.getAttribute("data-videoCover") || "";

    return {
      type: "videoAttachment",
      videoUrl,
      videoName,
      videoCover,
      children: [{ text: "" }], // void node 必须有一个空白 text
    };
  },
};

const confFile = {
  selector: 'a[data-w-e-type="fileAttachment"]',
  parseElemHtml(elem, children, editor) {
    // elem HTML 结构 <span data-w-e-type="mention" data-w-e-is-void data-w-e-is-inline data-value="张三" data-info="xxx">@张三</span>

    const fileStorageId = elem.getAttribute("data-fileStorageId") || "";
    const fileName = elem.getAttribute("data-fileName") || "";
    const fileExtension = elem.getAttribute("data-fileExtension") || "";
    const fileType = elem.getAttribute("data-fileType") || "";

    return {
      type: "fileAttachment",
      fileStorageId,
      fileName,
      fileExtension,
      fileType,
      children: [{ text: "" }], // void node 必须有一个空白 text
    };
  },
};

export default {
  confVideo,
  confFile,
};
